import { useSnapshot } from 'valtio'

import { type ReactElement, useEffect } from 'react'
import cn from 'classnames'
import { timeIntervalProxy, TimeIntervals } from '../timeIntervalProxy'
import { usdFormatter } from '../../../../../shared/utils/formattingUtils'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import {
  throttledFetchRecentSales,
  recentSalesProxy
} from './recentSalesProxy'
import SalesCard from './Components/SalesCard'
import { TransactionLineChart } from './Components/TransactionLineChart'

export function RecentSalesSubSection (): ReactElement {
  useEffect(() => {
    void throttledFetchRecentSales(TimeIntervals.Weekly)
  }, [])

  const {
    apiCall,
    parsedGraphData,
    mostRecentSummary
  } = useSnapshot(recentSalesProxy)

  const { timeInterval } = useSnapshot(timeIntervalProxy)
  const displayedtimeInterval = timeInterval === TimeIntervals.Weekly ? 'Weekly' : 'Monthly'
  let dStart = ''
  let dEnd = ''

  if (parsedGraphData.length > 0) {
    const first = parsedGraphData[0]
    if (first.data.length > 0) {
      dStart = first.data[0].x as string
      dEnd = first.data[first.data.length - 1].x as string
    }
  }

  return (
    <div className="w-1/2">
      <ErrorBox error={apiCall.error} additionalClasses="h-72">
        <div className="flex flex-row ">
          <SalesCard
            loading={apiCall.loading}
            title={`${displayedtimeInterval} Sales`}
            secondaryTitle="Count"
            amount={usdFormatter.format(mostRecentSummary.salesDollarsCents)}
            secondaryAmount={mostRecentSummary?.salesTxnsCount?.toString()}
            //yearlyChange={totalSales.yoyChange}
            additionalClasses="md:mr-6"
          />

          <SalesCard
            loading={apiCall.loading}
            title={`${displayedtimeInterval} Refunds`}
            secondaryTitle="Count"
            amount={usdFormatter.format(mostRecentSummary?.refundDollarsCents)}
            secondaryAmount={mostRecentSummary?.refundTxnsCount?.toString()}
            //yearlyChange={transactionsCount.yoyChange}
          />
        </div>

        <div className={cn('bg-white rounded shadow-lg p-4 mt-6 md:mr-4')}>
          <PlaceholderBox loading={apiCall.loading} rows={10} rowHeight="h-5">
            <div className="flex justify-between">
              <h4 className="text-gray-600 font-semibold">{`${dStart} - ${dEnd}`}</h4>
              <div>
                <span className="font-semibold mr-6">{usdFormatter.format(mostRecentSummary?.salesDollarsCents)}</span>
                <span className="text-gray-600 text-sm">Total Volume</span>
              </div>
            </div>
            <hr className="my-2" />
            <div className="h-96">
              <TransactionLineChart />
            </div>
          </PlaceholderBox>
        </div>
      </ErrorBox>
    </div>
  )
}
